import {
  GoToDetail,
  SignatureRegistry,
} from 'components/grid-dx/consult-buttons/index';
import {useGetToken} from 'components/hooks';
import IntegrityRoleGrid from 'components/UserRole';
import {Column, Lookup} from 'devextreme-react/data-grid';
import {lookupRole} from 'features/collaborator/component/CollaboGrid';
import {i18n2} from 'features/i18n/i18n';
import React from 'react';
import {useLoadCollaborator} from '../../collaborator/hooks';
import {LookupProps} from 'components/grid-dx/MasterGrid';
import {useIsTablet} from 'components/hooks/useIsTablet';
import {
  useActionButtonStyles,
  getActionColumnWidth,
} from 'components/grid-dx/styles/actionButtonStyles';

interface ButtonsProps {
  cwid: string;
  employee_Nr: number;
  data: any;
  props: any;
}

const Buttons = ({cwid, employee_Nr, data, props}: ButtonsProps) => {
  const id = props.key;
  const token = useGetToken();
  const isTablet = useIsTablet();
  const styles = useActionButtonStyles();
  return (
    <div
      className={isTablet ? styles.tabletContainer : styles.compactContainer}>
      <SignatureRegistry cwid={cwid} employee_Nr={employee_Nr} token={token} />
      <GoToDetail data={data} id={id} url={'/CollaboratorsDetails'} />
    </div>
  );
};

const CollaboratorReadOnly = () => {
  const loadCollaboratorReadOnly = useLoadCollaborator('CollaboratorReadOnly');
  const isTablet = useIsTablet();

  return (
    <IntegrityRoleGrid
      dataSource={loadCollaboratorReadOnly}
      id={['employee_Nr']}
      allowIntegrity={false}
      allowActions={false}
      exportName="Collaborator-consult-export">
      <Column caption={i18n2._('Numero de empleado')} dataField="employee_Nr" />
      <Column caption={i18n2._('Nombre')} dataField="name" width={200} />
      <Column caption={i18n2._('CWID')} dataField="cwid" />
      <Column caption={i18n2._('Sector')} dataField="sector_Name" />
      <Column caption={i18n2._('Perfil')} dataField="profile_Web_Name" />
      <Column caption={i18n2._('Turno')} dataField="shift_Name" />
      <Column caption={i18n2._('Role')} dataField="role" visible={false}>
        <Lookup
          dataSource={lookupRole}
          valueExpr="id"
          displayExpr={(item: LookupProps) => {
            return i18n2._(item ? item.name : '');
          }}
        />
      </Column>
      <Column caption={i18n2._('OnTime (%)')} dataField="onTimeRate" />
      <Column caption={i18n2._('Asistencia') + '(%)'} dataField="presentRate" />
      <Column caption={i18n2._('Aprobados') + '(%)'} dataField="passRate" />
      <Column
        caption=""
        cellComponent={(e: any) => (
          <Buttons
            cwid={e.data.data.cwid}
            employee_Nr={e.data.data.employee_Nr}
            data={e.data.data}
            props={e.data}
          />
        )}
        width={getActionColumnWidth(2, isTablet)}
        fixed
        alignment="right"
      />
    </IntegrityRoleGrid>
  );
};

export default CollaboratorReadOnly;
